<template>
  <div class="zcredit-card-data">
    <div style="display: none;" class="info-amount-payments">
      {{currentAmountPayments}}
    </div>
    <div style="display: none;" v-on:click="toggleElement()" class="show-amount-payments">
      בחר כמות תשלומים
    </div>
    <select style="display: none;" size="4" v-model="modelValue.amount_payments" @change="$emit('change')" v-bind:class="isVisible ? '': 'credit-card-data-invisible'">
      <option v-on:click="toggleElement()" v-for="opt in modelValue.options" :value="opt.value">
        {{ opt.title }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: "PaymentZcreditCardData",
  emits: ['change'],
  data() {
    return {
      isVisible: true,
      currentAmountPayments: '',
    }
  },
  props: {
    modelValue: {}
  },
  mounted() {
    this.$emit('change')
    this.choiceSelectedPaymentData();
  },
  methods: {
    toggleElement() {
      this.isVisible = !this.isVisible;
      this.choiceSelectedPaymentData();
    },
    choiceSelectedPaymentData() {
      for (let x = 0; x <  this.modelValue.options.length; x++) {
        if(this.modelValue.options[x].value === this.modelValue.amount_payments) {
          this.currentAmountPayments = this.modelValue.options[x].title;
        }
      }
    }
  },
  computed: {
  }
}
</script>

<style scoped>
  .zcredit-card-data {
    float: left;
    margin-left: 0;
    margin-right: auto;
    position: relative;
    top: -30px;
    width: 48%;
  }

  .info-amount-payments {
    direction: ltr;
    font-size: 18px;
    font-weight: 600;
    position: absolute;
    left: 20px;
    top: -91px;
  }

  .credit-card-data-invisible {
    display: none;
  }

  .show-amount-payments {
    position: absolute;
    top: -45px;
    right: 20px;
    cursor: pointer;
    color: #888888;
    text-decoration: underline;
    font-size: 14px;
  }

  .zcredit-card-data select {
    width: 100%;
    height: 230px;
    overflow: auto;
    background: #F2F2F2;
    padding: 30px;
  }

  .zcredit-card-data select option {
    padding: 10px;
    border-bottom: 1px solid #E5E5E5;
    direction: ltr;
    text-align: right;
    color: #000000;
  }

  .zcredit-card-data select option:checked {
    font-weight: 600;
  }

  @media (max-width: 1600px) {
    .info-amount-payments {
      top: -60px;
    }

    .show-amount-payments {
      top: -25px;
    }
  }

  @media (max-width: 768px) {
    .zcredit-card-data {
      width: 100%;
      top: -26px;
    }
  }

  @media (max-width: 607px) {
    .info-amount-payments {
      top: -60px;
    }

    .show-amount-payments {
      top: -25px;
    }
  }

  @media (max-width: 480px) {
    .info-amount-payments {
      top: -90px;
    }

    .show-amount-payments {
      top: -50px;
    }
  }

  @media (max-width: 375px) {
    .info-amount-payments {
      top: -60px;
    }

    .show-amount-payments {
      top: -25px;
    }
  }
</style>
